import React, { useState } from 'react';
import PoliticalStaking from './PoliticalStaking';
import PoliticalVoting from './PoliticalVoting';

const PoliticalChamber = ({ userData, currentUser, activeVote, onClose }) => {
  const [activeTab, setActiveTab] = useState('staking'); 
  
  const THEME_TEAL = "#50e3c2";
  const TEXT_GREY = "#888";

  const getTabStyle = (tabID) => ({
    flex: 1,
    padding: '12px',
    background: activeTab === tabID ? 'rgba(80, 227, 194, 0.1)' : 'transparent',
    border: 'none',
    borderBottom: `2px solid ${activeTab === tabID ? THEME_TEAL : '#222'}`,
    color: activeTab === tabID ? THEME_TEAL : '#444',
    cursor: 'pointer',
    fontFamily: 'monospace',
    fontSize: '0.7rem',
    fontWeight: 'bold',
    transition: '0.2s'
  });

  return (
    <div 
      style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        background: 'rgba(0,0,0,0.9)', backdropFilter: 'blur(8px)',
        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000
      }} 
      onClick={onClose}
    >
      <div 
        className="jetbrains-card" 
        style={{ 
          width: '480px', height: '600px', background: '#0a0a0a', 
          border: '1px solid #333', position: 'relative', display: 'flex', flexDirection: 'column',
          padding: '0'
        }} 
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', background: '#050505', borderBottom: '1px solid #222', zIndex: 10002 }}>
          <button style={getTabStyle('staking')} onClick={() => setActiveTab('staking')}>
            STAKING
          </button>
          <button style={getTabStyle('voting')} onClick={() => setActiveTab('voting')}>
            VOTING
          </button>
        </div>

        <button 
          onClick={onClose} 
          style={{
            position: 'absolute', top: '0px', right: '0px', width: '28px', height: '28px', 
            background: '#1a1a1a', border: '1px solid #333', color: THEME_TEAL, 
            cursor: 'pointer', zIndex: 10005, fontSize: '20px', borderRadius: '4px'
          }}
        >
          ×
        </button>

        <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          
          {/* HEADER */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div style={{ textAlign: 'right', marginRight: '35px' }}>
              <div style={{ fontSize: '0.8rem', color: TEXT_GREY }}>VP BALANCE</div>
              <div style={{ fontSize: '0.8rem', color: THEME_TEAL }}>{userData?.userPoliticalPoints?.toFixed(4)}</div>
            </div>
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {activeTab === 'staking' ? (
              <PoliticalStaking userData={userData} currentUser={currentUser} />
            ) : (
              <PoliticalVoting userData={userData} currentUser={currentUser} activeVote={activeVote} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticalChamber;